var map = {
	"./banner-black.svg": [
		1388,
		1388
	],
	"./banner-white.svg": [
		5210,
		5210
	],
	"./belly-0.svg": [
		2115,
		2115
	],
	"./belly-1.svg": [
		9074,
		9074
	],
	"./belly-2.svg": [
		817,
		817
	],
	"./belly-3.svg": [
		6016,
		6016
	],
	"./belly-4.svg": [
		3487,
		3487
	],
	"./belly-5.svg": [
		910,
		910
	],
	"./hair.svg": [
		8504,
		8504
	],
	"./hip-0.svg": [
		832,
		832
	],
	"./hip-1.svg": [
		3073,
		3073
	],
	"./hip-2.svg": [
		4386,
		4386
	],
	"./hip-3.svg": [
		2323,
		2323
	],
	"./hip-4.svg": [
		7692,
		7692
	],
	"./hip-5.svg": [
		8317,
		8317
	],
	"./shoulder-0.svg": [
		3635,
		3635
	],
	"./shoulder-1.svg": [
		5698,
		5698
	],
	"./shoulder-2.svg": [
		737,
		737
	],
	"./shoulder-3.svg": [
		8496,
		8496
	],
	"./shoulder-4.svg": [
		8031,
		8031
	],
	"./shoulder-5.svg": [
		5454,
		5454
	],
	"./skin-type-combination.svg": [
		1813,
		4194
	],
	"./skin-type-dry.svg": [
		5152,
		5152
	],
	"./skin-type-normal.svg": [
		4328,
		4328
	],
	"./skin-type-oily.svg": [
		4420,
		4420
	],
	"./skin-type-sensitive.svg": [
		9671,
		9671
	],
	"./skin-undertone-cool.svg": [
		4520,
		4520
	],
	"./skin-undertone-neutral.svg": [
		4831,
		7212
	],
	"./skin-undertone-warm.svg": [
		2588,
		2588
	],
	"./tummy-0.svg": [
		1311,
		1311
	],
	"./tummy-1.svg": [
		7022,
		7022
	],
	"./tummy-2.svg": [
		7741,
		7741
	],
	"./tummy-3.svg": [
		2284,
		2284
	],
	"./tummy-4.svg": [
		9027,
		9027
	],
	"./tummy-5.svg": [
		8450,
		8450
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 7053;
module.exports = webpackAsyncContext;